// src/pages/_ScaffoldPage.jsx
// Shared scaffold shell for feature and comparison pages.
// Replace with full content once copywriting is done.

const s = {
  page: { background: '#0a0a0a', color: '#c9d1d9', fontFamily: "'DM Sans', system-ui, sans-serif", minHeight: '100vh', padding: '64px 24px' },
  container: { maxWidth: 860, margin: '0 auto' },
  nav: { marginBottom: 48, fontSize: 14 },
  navLink: { color: '#3ddc84', textDecoration: 'none' },
  badge: { display: 'inline-block', background: '#0E180F', color: '#3ddc84', border: '1px solid #2db870', borderRadius: 4, padding: '4px 12px', fontSize: 12, fontFamily: "'IBM Plex Mono', 'Courier New', monospace", marginBottom: 24 },
  h1: { fontSize: 'clamp(28px, 5vw, 48px)', fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 800, color: '#c9d1d9', margin: '0 0 20px', lineHeight: 1.15 },
  p: { fontSize: 18, color: '#8b949e', lineHeight: 1.7, maxWidth: 620, marginBottom: 40 },
  cta: { display: 'inline-block', padding: '14px 32px', background: '#3ddc84', color: '#0a0a0a', fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700, fontSize: 16, borderRadius: 8, textDecoration: 'none', marginBottom: 80 },
  placeholder: { background: '#111111', border: '1px dashed #1c2333', borderRadius: 12, padding: 48, textAlign: 'center', color: '#8b949e', fontSize: 14 },
  breadcrumb: { fontSize: 12, color: '#8b949e', marginBottom: 8, fontFamily: "'IBM Plex Mono', 'Courier New', monospace" },
};

export default function ScaffoldPage({ badge, title, description, canonical, cta = 'Get Started Free →' }) {
  const url = `https://nuvportos.com${canonical}`;
  return (
    <div style={s.page}>
      <div style={s.container}>
        <nav style={s.nav}>
          <a href="/" style={s.navLink}>← Nuvport OS</a>
        </nav>
        <div style={s.breadcrumb}>nuvportos.com{canonical}</div>
        <div style={s.badge}>{badge}</div>
        <h1 style={s.h1}>{title}</h1>
        <p style={s.p}>{description}</p>
        <a href="/" style={s.cta}>{cta}</a>

        {/* Content placeholder */}
        <div style={s.placeholder}>
          <p style={{ margin: 0, marginBottom: 8, fontFamily: "'IBM Plex Mono', 'Courier New', monospace", color: '#3ddc84' }}>// CONTENT COMING SOON</p>
          <p style={{ margin: 0 }}>Full feature content, screenshots, and use cases will be added here.</p>
          <p style={{ margin: '8px 0 0', fontSize: 12 }}>Canonical: <span style={{ color: '#3ddc84' }}>{url}</span></p>
        </div>
      </div>
    </div>
  );
}
